import React from "react";
import Link from "components/link";
import Image from "components/image";
import ButtonLink from "components/button-link";
import { formatDateWithYear } from "helpers/date";

const FeaturedBlogs = ({ data }) => {
	const { title, blogs, cta } = data;

	return (
		<div className="flex flex-col standard-section-width mx-auto gap-10 items-center">
			<h2>{title}</h2>
			<div className="w-full text-center overflow-hidden">
				<div className="flex overflow-auto gap-6 horizontal-padding no-scrollbar">
					{blogs.map((blog) => (
						<Link key={blog.handle} to={`/blogs/${blog.category.handle}/${blog.handle}`}
							className="group flex flex-col w-full cursor-pointer min-w-72">
							<Image image={blog.featuredImage} className="aspect-video" />
							<div className="flex flex-col items-start gap-2 py-8">
								<h4 className="line-clamp-1 group-hover:underline text-start">{blog.title}</h4>
								<p className="text-darkGray uppercase">{formatDateWithYear(blog.date)}</p>
								<p className="line-clamp-3 text-lg leading-7 text-start">{blog.excerpt}</p>
							</div>
						</Link>
					))}
				</div>
			</div>
			<div className="horizontal-padding flex w-full justify-center sm:w-auto">
				<ButtonLink data={cta} className="text-center" />
			</div>
		</div>
	);
};

export default FeaturedBlogs;
